import api from '../config/api';
import { API_URLS } from '../config/urls';

export const faqService = {
    getFaqs: async () => {
        const response = await api.get(API_URLS.FAQS);
        return response.data;
    },
};
